/* PP3 — reveal on scroll, compartilhado. Mora num asset (e não dentro do feed) para que
   qualquer section funcione sozinha: se o merchant apagar o feed, banda/vault/callout
   continuam aparecendo. O CSS só esconde quando html.pp3-rev existe, e essa classe é posta
   pelo inline síncrono de cada section — se ESTE arquivo falhar, o guard abaixo revela tudo. */
(function () {
  if (window.__pp3Rev) return;
  window.__pp3Rev = 1;

  function targets() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.pp3-rev'),
      function (el) { return el !== document.documentElement && el !== document.body; }
    );
  }

  function revealAll() { targets().forEach(function (el) { el.classList.add('in'); }); }

  if (!('IntersectionObserver' in window)) { revealAll(); return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

  function scan() { targets().forEach(function (el) { if (!el.classList.contains('in')) io.observe(el); }); }
  window.__pp3RevScan = scan;

  scan();
  document.addEventListener('shopify:section:load', scan);
  // rede de segurança: se por qualquer motivo nada foi revelado em 2,5 s, revela tudo.
  setTimeout(function () {
    if (!document.querySelector('.pp3-rev.in')) revealAll();
  }, 2500);
})();
